import { render, staticRenderFns } from "./conf_query.vue?vue&type=template&id=2d0e9640&scoped=true&"
import script from "./conf_query.vue?vue&type=script&lang=js&"
export * from "./conf_query.vue?vue&type=script&lang=js&"
import style0 from "./conf_query.vue?vue&type=style&index=0&id=2d0e9640&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e9640",
  null
  
)

export default component.exports